import { TICKET_STATUS } from '@/pages/Ticket/Email/utils/enum';

// eslint-disable-next-line import/prefer-default-export
export const EMPTY_VALUE = '(空)';
export const TABLE_EMPTY_VALUE = '--';
export const DATA_EMPTY_VALUE = '-';
export const EMAIL_EMPTY_TITLE = '（无主题）';

// 工单时间格式化字符串
export const TICKET_TIME_FORMAT_TEXT = 'YYYY/MM/DD HH:mm';

// 本地存储模块名称

export enum LocalStoreModule {
  EmailEdit = 'emailEdit',
  SaasEdit = 'saasEdit',
  EmailRemark = 'emailRemark',
  EmailAttachment = 'emailAttachment',
  EmailRemarkAttachment = 'emailRemarkAttachment',
  EmailLogList = 'emailLogList',
  SaaSLogList = 'saasLogList',
}

// 默认访问的 URL 列表
export const DEFAULT_ACCESS_URL_MAP = {
  dashboard: '/dashboard', // 仪表盘（dashboard）
  'email-ticket': '/email-ticket/unprocessing', // 邮件-待处理（email-ticket/unprocessing）
  'saas-dispute': '/saas-ticket/unprocessing', // SaaS-待处理（saas-ticket/unprocessing）
  'user-accounts': '/system/accounts', // 用户管理（/system/accounts）
  'role-permissions': '/system/role', // 角色管理（/system/role）
  'preset-script': '/knowledge-base/preset-script', // 预设话术管理（/knowledge-base/preset-script）
};

export const NO_MESSAGE = '暂无消息';

export const FROM_TO_LOGIN = 'fromToLogin';

// 工单状态选项
export const ticketOptions = [
  { label: '待处理', value: TICKET_STATUS.UNPROCESSING, color: '#ea1c1c' },
  { label: '待定', value: TICKET_STATUS.PENDING, color: '#d7b03b' },
  { label: '已解决', value: TICKET_STATUS.RESOLVED, color: '#0a8c43' },
  { label: '处理中', value: TICKET_STATUS.WAITING_FOR_CUSTOMERS, color: '#1890ff' },
  // { label: '等待第三方', value: TICKET_STATUS.WAITING_FOR_A_THIRD_PARTY, color: 'gray' },
];

// 工单状态选项映射
export const ticketsOptionMap = {
  [TICKET_STATUS.UNPROCESSING]: '待处理',
  [TICKET_STATUS.PENDING]: '待定',
  [TICKET_STATUS.RESOLVED]: '已解决',
  [TICKET_STATUS.WAITING_FOR_CUSTOMERS]: '处理中',
  // [TICKET_STATUS.WAITING_FOR_A_THIRD_PARTY]: '等待第三方',
};
